import { boolFromUnknown } from '@/lib/primitive-utils';

export function resolveNotation(builder: Record<string, unknown>): string {
    return typeof builder.notation === 'string' ? builder.notation : '';
}

export function resolveRequireUnits(builder: Record<string, unknown>): boolean {
    return boolFromUnknown(builder.require_units);
}
